import {
	Drawer,
	DrawerBody,
	DrawerContent,
	DrawerHeader,
	DrawerOverlay,
} from "@chakra-ui/react";
import { useEffect, useMemo, useState } from "react";

import { ReactComponent as BackIcon } from "../../../../assets/icons/close.svg";
import { TabHeader } from "components/TabHeader";
import { Button } from "newui/components/Button";
import { Input } from "components/RFQ/Input/Input";
import { useSelector } from "react-redux";
import { getProjectAll } from "actions/RFQ/projectsAction";
import { assignToProject } from "actions/RFQ/supplierListsActions";
import { Link, navigate } from "@reach/router";
import { useCurrentCompanyId } from "hooks/auth";
import { useAuthContext } from "newui/features/Auth/context/AuthContextProvider";

const AddtoProject = ({ isOpen, onClose, listId, ...props }) => {
	const [selectedProject, setSelectedProject] = useState(null);
	const [projects, setProjects] = useState(
		useSelector((state) => state.rfq.projects?.projects?.allProject?.data) || []
	);
	const projectsOptions = useMemo(
		() =>
			projects?.map((project) => ({
				id: project.id,
				value: project.id,
				label: project.name,
			})),
		[projects]
	);
	const companyId = useCurrentCompanyId();
	const { clientPaths } = useAuthContext();

	useEffect(() => {
		if (!projects?.length > 0) {
			getProjectAll().then((res) => {
				setProjects(res?.allProject?.data);
			});
		}
		
	}, []);

	const addingToProject = () => {
		assignToProject(listId, [selectedProject.id])
			.then((res) => {
				const projectSelected = selectedProject;

				setSelectedProject(null);
				onClose();

				if (res?.data?.status) {
					navigate(
						`/account/${companyId}/projects/${projectSelected.id}/${projectSelected.label?.toLowerCase().replace(/ /g, "-")}`
					);
				}
			})
			.catch((err) => console.log(err));
	};

	const CloseButton = () => {
		return (
			<Button
				btntype={"icon"}
				onClick={() => {
					setSelectedProject(null);
					onClose();
				}}
			>
				<BackIcon
					style={{ width: "25px", height: "25px", marginRight: "0px" }}
				/>
			</Button>
		);
	};

	return (
		<div>
			<Drawer
				placement={"right"}
				isOpen={isOpen}
				onClose={() => {
					setSelectedProject(null);
					onClose();
				}}
				size="xl"
				{...props}
			>
				<DrawerOverlay
					onClick={() => {
						setSelectedProject(null);
						onClose();
					}}
				/>
				<DrawerContent>
					<DrawerHeader
						borderBottomWidth="1px"
						className="px-0 py-6 text-black"
					>
						<TabHeader
							noDivider={true}
							heading={"Attach Supplier List to Project"}
							description={
								"Select the relevant project/asset for the Supplier List."
							}
						>
							<CloseButton />
						</TabHeader>
					</DrawerHeader>
					<DrawerBody>
						<div className="max-h-[calc(100vh - 100px)] mb-8 pt-6">
							<Input
								onChange={setSelectedProject}
								type="select"
								label="Select Project/Asset"
								placeholder="Select Project/Asset"
								options={projectsOptions}
								testId="select-project"
							/>
						</div>
						<div className="mb-8">
							<Button
								width="100%"
								onClick={addingToProject}
								disabled={selectedProject?.id ? false : true}
								data-testid="submit-project"
							>
								Attach to Project/Asset
							</Button>
						</div>
						<div className="text-center">
							<p>
								Haven't created the project yet?
								<Link to={clientPaths.newRfxProjectWithSupplierList(listId)}>
									{" "}
									Start here
								</Link>
							</p>
						</div>
					</DrawerBody>
				</DrawerContent>
			</Drawer>
		</div>
	);
};

export default AddtoProject;
